<div class="em-c-loader loader">
  <img src="assets/unity-1.6.0/images/icon-spinner.svg" alt="Loading" />
</div>
